// Indian currency formatting (₹19,00,000.00) using Intl API with en-IN
export function formatInr(value) {
  if (value === null || value === undefined || value === "") return "-";
  const num = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(num)) return "-";
  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
  return `\u20B9${formatted}`;
}

export function parseInrInput(str) {
  if (!str) return null;
  const cleaned = String(str).replace(/[^0-9.\-]/g, "");
  const n = Number(cleaned);
  return Number.isNaN(n) ? null : n;
}
